<nav class="breadcrumbs">
  @for (breadcrumb of breadcrumbs; track $index;) {
    <ng-container>
      <button class="breadcrumb-button" [class.active]="!breadcrumb.disabled" [class.disabled]="breadcrumb.disabled"
              [disabled]="breadcrumb.disabled" (click)="onBreadcrumbClick(breadcrumb)">
        {{ breadcrumb.label | translate }}
      </button>
      @if (!$last) {
        <span class="breadcrumb-separator">/</span>
      }
    </ng-container>
  }

</nav>
